import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select, Functions } from "rhombus-react";
import { loadAdvertiserObjectives, selectActiveAdvertiserObjectives } from "reducers/AdvertiserDetails";

export default function AdvertiserObjective({ onObjective, selectedObjective, required, meta, targetMethod }) {
	const dispatch = useDispatch();
	const { advertiserObjectives, advertiserId } = useSelector((state) => {
		return {
			advertiserObjectives: selectActiveAdvertiserObjectives(state, targetMethod),
			advertiserId: state.advertiserDetails.data.id,
		};
	});

	useEffect(() => {
		if (advertiserId) {
			dispatch(loadAdvertiserObjectives(advertiserId));
		}
	}, [advertiserId]);

	return (
		<Select
			label="Advertiser Objective"
			placeholder="Select Advertiser Objective"
			options={advertiserObjectives}
			onChange={val => onObjective(val)}
			value={selectedObjective}
			onMenuScrollToBottom={Functions.noop}
			required={required}
			meta={meta}
		/>
	);
}
